import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getFavorito, deleteFavorito } from '../../services/apiFavorito';
import { getAnuncios } from '../../services/apiAnuncio';
import { getTodasCidades } from '../../services/apiCidade';
import { getImagemCapa } from '../../services/apiImagem';
import notFound from "./notFound.svg";
import Image from 'react-bootstrap/Image';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faHeart } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import { sucessoToastify, erroToastify } from '../../shared/validacaoToastify';
import imagem from "../../shared/assets/logoCard.svg";
import { useAuth } from '../../context/AuthContext';
import "../../components/meusAnunciosCard/meuAnuncioCard.css";


export default function MeusFavoritos() {
  const cdUsuario = localStorage.getItem("cdUsuario") || '';
  const [anuncios, setAnuncios] = useState<any[]>([]);
  const [cidades, setCidades] = useState<any[]>([]);
  const [imagens, setImagens] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [favoritados, setFavoritados] = useState<any[]>([]);
  const { isAuthenticated, logout } = useAuth();

  const carregarDados = async () => {
    setLoading(true);
    try {
      if (isAuthenticated) {
        const responseFavoritos = await getFavorito(cdUsuario.toString());
        const favoritosArray = Array.isArray(responseFavoritos.data) ? responseFavoritos.data : [];
        setFavoritados(favoritosArray);

        const imagensFavoritas = await Promise.all(favoritosArray.map(async (favorito: any) => {
          const imagemResponse = await getImagemCapa(favorito.cdAnuncio);
          if (imagemResponse) {
            const imagemPrincipal = imagemResponse;
            const tipoArquivo = imagemPrincipal.nmTipoArquivo.startsWith('.') ? imagemPrincipal.nmTipoArquivo.slice(1) : imagemPrincipal.nmTipoArquivo;
            const imageUrl = `data:image/${tipoArquivo};base64,${imagemPrincipal.mdArquivo}`;
            return { [favorito.cdAnuncio]: imageUrl };
          } else {
            return { [favorito.cdAnuncio]: null };
          }
        }));

        const imagensObject = imagensFavoritas.reduce((acc, curr) => {
          return { ...acc, ...curr };
        }, {} as { [key: string]: string | null });

        setImagens(imagensObject);

        const responseCidades = await getTodasCidades();
        setCidades(responseCidades);

        const responseAnuncios = await getAnuncios('1');
        const todosAnuncios = responseAnuncios;

        const anunciosFavoritos = todosAnuncios.filter((anuncio: any) =>
          favoritosArray.some(favorito => favorito.cdAnuncio === anuncio.cdAnuncio)
        );

        setAnuncios(anunciosFavoritos);
        setLoading(false);
      }

    } catch (error) {

      setLoading(false);
    }
  };
  
  useEffect(() => {
    carregarDados();
  }, []);

  const desfavoritarAnuncio = async (cdAnuncio: number, cdFavorito: number) => {
    try {
      const cdUsuario = localStorage.getItem('cdUsuario') || '0';
      const dtAtual = new Date().toISOString();

      const data = {
        cdFavorito: cdFavorito,
        cdUsuario: parseInt(cdUsuario),
        cdAnuncio: cdAnuncio,
        dtSelecao: dtAtual,
        cdUsuarioInc: parseInt(cdUsuario),
        cdUsuarioAlt: parseInt(cdUsuario),
        dtInclusao: dtAtual,
        dtAlteracao: dtAtual,
        dmSituacao: false
      };

      const response = await deleteFavorito({ data });

      sucessoToastify("Anúncio desfavoritado com sucesso!");

      setTimeout(() => {
        setAnuncios(anuncios.filter(anuncio => anuncio.cdAnuncio !== cdAnuncio));
        setFavoritados(favoritados.filter(fav => fav.cdAnuncio !== cdAnuncio));
      }, 1000);

      // Atualiza o estado removendo o anúncio desfavoritado
      setAnuncios(anuncios.filter(anuncio => anuncio.cdAnuncio !== cdAnuncio));
      setFavoritados(favoritados.filter(fav => fav.cdAnuncio !== cdAnuncio));
    } catch (error) {
      console.error('Erro ao desfavoritar anúncio:', error);
    }
  };

  return (
    <div className="container-sm mt-2">
      <ToastContainer />
      <div className="anuncios-container">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <div>
            <div className='container mt-2'>
              <h4>Meus Favoritos</h4>
              <hr className='my-4' />
            </div>
            {anuncios.length > 0 ? (
              anuncios.map((anuncio: any, index: number) => {
                const imageUrl = imagens[anuncio.cdAnuncio];
                const favorito = favoritados.find(fav => fav.cdAnuncio === anuncio.cdAnuncio);
                return (
                  <div key={index} className="container row mt-3 custom-rounded bg-light">
                    <div className="col-12 col-md-3 bg-ligth containerImagem">
                      {imageUrl ? (
                        <Image src={imageUrl} alt={anuncio.nmAnuncio} style={{ height: '100%', maxHeight: '10rem', width: "100%", objectFit: 'cover', border: '1px solid #d69909', padding: '0', borderRadius: '10px' }} thumbnail />
                      ) : (
                        <div className="no-image-placeholder">
                          <Image
                            src={imagem}
                            alt={anuncio.nmAnuncio}
                            style={{
                              maxHeight: "10rem",
                              width: "100%",
                              objectFit: "contain",
                              background: '#050a30',
                              border: '1px solid #d69909',
                              padding: '0',
                              borderRadius: '4px'
                            }}
                            thumbnail
                          />

                        </div>
                      )}
                    </div>
                    <div className="col-12 col-md-6 p-1 bg-light d-flex flex-column justify-content-between" style={{ height: "10rem" }}>
                      <h5 className="text-truncate mb-1 ps-2 pt-2">{anuncio.nmAnuncio}</h5>
                      <p className="two-line-clamp ps-2">{anuncio.dsAnuncio}</p>
                      <div className="d-flex mt-auto text-muted" style={{ fontSize: "0.8rem" }}>
                        <span className="pe-1 ps-2">{anuncio.dmTipoAnuncio ? "Produto" : "Serviço"}</span>
                        <p className="pe-1">-</p>
                        {cidades.map((cidade) => (
                          <p key={cidade.cdCidade}>
                            {anuncio.cdCidade === cidade.cdCidade && cidade.nmCidade}
                          </p>
                        ))}
                      </div>
                    </div>
                    <div className="d-flex flex-column col-12 col-md-3 p-1 bg-light text-end pe-4 justify-content-between pt-2">
                      <p>R$ {anuncio.vlAnuncio}</p>
                      <div>
                        <Link to={`/milshop/anuncio/ver-detalhes/${anuncio.cdAnuncio}`}>
                          <FontAwesomeIcon
                            icon={faEye}
                            className="me-2"
                            style={{ color: "#002f52" }}
                          />
                        </Link>
                        <FontAwesomeIcon
                          icon={faHeart}
                          className="me-2"
                          style={{ color: "#7B0323", cursor: "pointer" }}
                          onClick={() => desfavoritarAnuncio(anuncio.cdAnuncio, favorito.cdFavorito)}
                        />
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="d-flex justify-content-center align-items-center text-center" style={{ minHeight: "40vh" }}>
                <div>
                  <h5 className="mb-1">Nenhum favorito encontrado...</h5>
                  <img
                    src={notFound}
                    className="mx-auto"
                    style={{
                      maxHeight: "100%",
                      width: "10rem",
                      objectFit: "cover",
                    }}
                    alt="Imagem não encontrada"
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
